import React from 'react'
import { useForm } from '@inertiajs/react'
import AuthLayout from '@/layouts/AuthLayout'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

type Props = {
  errors?: Record<string, string[]>
}

export default function Signup({ errors = {} }: Props) {
  const { data, setData, post, processing } = useForm({
    email: '',
    username: '',
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/signup', { replace: true })
  }

  return (
    <AuthLayout>
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>アカウント作成</CardTitle>
          <CardDescription>
            konreji を始めましょう
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">メールアドレス</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                required
              />
              {errors.email && (
                <p className="text-sm text-destructive">{errors.email[0]}</p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="username">ユーザー名</Label>
              <Input
                id="username"
                type="text"
                autoComplete="username"
                value={data.username}
                onChange={(e) => setData('username', e.target.value)}
                placeholder="my-username"
                required
              />
              {errors.username && (
                <p className="text-sm text-destructive">{errors.username[0]}</p>
              )}
              <p className="text-xs text-muted-foreground">
                リポジトリのパスに使用されます（例: username/my-app）。英数字とハイフン、3〜39文字
              </p>
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">パスワード</Label>
              <Input
                id="password"
                type="password"
                autoComplete="new-password"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                minLength={12}
                required
              />
              {errors.password && (
                <p className="text-sm text-destructive">{errors.password[0]}</p>
              )}
              <p className="text-xs text-muted-foreground">
                12文字以上、特殊文字を1文字以上含む
              </p>
            </div>

            <div className="space-y-2">
              <Label htmlFor="password_confirmation">パスワード（確認）</Label>
              <Input
                id="password_confirmation"
                type="password"
                autoComplete="new-password"
                value={data.password_confirmation}
                onChange={(e) => setData('password_confirmation', e.target.value)}
                minLength={12}
                required
              />
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-4 pt-6">
            <Button type="submit" className="w-full" disabled={processing}>
              アカウント作成
            </Button>
            <p className="text-sm text-muted-foreground">
              すでにアカウントをお持ちの方は{' '}
              <a href="/login" className="text-primary hover:underline">
                ログイン
              </a>
            </p>
          </CardFooter>
        </form>
      </Card>
    </AuthLayout>
  )
}
